import { FC, useCallback } from 'react';
import { CampaignCarousel } from '~/components/campaign-carousel';
import { ViewTracker } from '~/components/view-tracker';
import { ClickPosition } from '~/utils/click-position';
import { ModuleType } from '~/utils/module-type';
import { $CurrentHashtagId } from '~/routes/topic.$hashtag_id/shared/atoms';
import { useAtomValue } from 'jotai';

import './style.scss';

export default function HashtagCampaignSection(): JSX.Element {
  const hashtagId = useAtomValue($CurrentHashtagId);

  const sendTrackingEvent = useCallback(() => {
    window.Tea('wap_cta_show', {
      current_page_module: ModuleType.activity_banner,
      current_position: ClickPosition.activity_banner,
      page_id: hashtagId,
    });
  }, []);

  return (
    <ViewTracker onView={sendTrackingEvent}>
      <section id="hashtag-campaign">
        <CampaignCarousel />
      </section>
    </ViewTracker>
  );
}
